<template lang="html">
  <div id="availability-scale-model">
    <iframe name="scaleModel" id="scale-model"
    src="/static/model/index.html" frameborder="0" />
    <transition name="fade">
      <div class="interact-instructions"
      @click="showInstrctuions = false"
      @mousemove="showInstrctuions = false"
      @touchmove="showInstrctuions = false"
      v-show="showInstrctuions">
        <div class="interact-instructions-text py-2 px-3">Drag &amp; Zoom</div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

export default {
  props: {
    showUnits: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loaded: false,
      resizingModel: false,
      showInstrctuions: true,
      firstLoadRotation: false
    };
  },
  computed: {
    ...mapState({
      colours: state => state.project.theme.colours,
      selectedUnitName: state => state.floorplans.selectedUnitName
    }),
    ...mapGetters({
      filteredFloorplanList: 'floorplans/filteredFloorplanList',
      filteredUnitList: 'floorplans/filteredUnitList',
      floorplanAvailableUnitList: 'floorplans/floorplanAvailableUnitList',
      getFloorplanById: 'floorplans/getFloorplanById',
      getFloorplanByUnitName: 'floorplans/getFloorplanByUnitName',
      isFiltered: 'floorplans/isFiltered',
      getExposureByUnitName: 'floorplans/getExposureByUnitName'
    }),
    getView() {
      let exposureArr = [];
      if (this.selectedUnitName) {
        exposureArr = this.getExposureByUnitName(this.selectedUnitName);
      } else if (this.$route.name === 'FloorplanDetail') {
        exposureArr = this.getFloorplanById(this.$route.params.id).current.exposure;
      } else {
        exposureArr = this.filteredFloorplanList[0].suites[0].exposure;
      }
      console.log(exposureArr)
      if (exposureArr.includes('n')) {
        if (exposureArr.includes('e')) {
          // return 'ne';
          return 304;
        } else if (exposureArr.includes('w')) {
          // return 'nw';
          return 50;
        }
        return 327;
        // return 'n';
      } else if (exposureArr.includes('s')) {
        if (exposureArr.includes('e')) {
          // return 'se';
          return 217;
        } else if (exposureArr.includes('w')) {
          // return 'sw';
          return 136;
        }
        return 163;
        // return 's';
      } else if (exposureArr.includes('e')) {
        // return 'e';
        return 280;
      }
      // return 'w';
      return 112;
    }
  },
  methods: {
    ...mapMutations({
      setPageReady: 'ui/setPageReady',
      setSelectedUnitName: 'floorplans/setSelectedUnitName'
    }),
    clearModelUnits() {
      try {
        window.frames.scaleModel.pc.app.fire('hideUnits');
      } catch (e) {
        console.warn('error hiding units', e);
      }
    },
    showModelUnits() {
      try {
        window.frames.scaleModel.pc.app
          .fire('showFilteredUnits', this.filteredUnitList);
        if (this.$route.name === 'FloorplanDetail') {
          window.frames.scaleModel.pc.app
            .fire('showFloorplanUnits', this.floorplanAvailableUnitList(this.$route.params.id));
          this.setDirection();
        }

        if ((this.selectedUnitName === '3B9B' || this.selectedUnitName === '3B9A')
          && this.$route.name === 'FloorplanDetail'
          && this.getFloorplanById(this.$route.params.id).current.name === 'X Level 9') {
          window.frames.scaleModel.pc.app
            .fire('showSelectedUnits', ['3B9A', '3B9B']);
        } else  if (this.selectedUnitName) {
          window.frames.scaleModel.pc.app
            .fire('showSelectedUnits', [this.selectedUnitName]);
        }
      } catch (e) {
        console.warn('error showing units', e);
      }
    },
    setDirection() {
      try {
        window.frames.scaleModel.pc.app
          .fire('setDirectionVal', this.getView, 250);
        console.log('setView', this.getView);
        window.frames.scaleModel.pc.app
          .fire('setPitchVal', -16.5);
      } catch (e) {
        console.warn('error setting direction', e);
      }
    },
    resetView() {
      try {
        // window.frames.scaleModel.pc.app.fire('resetView');
        // window.frames.scaleModel.pc.app
        //   .fire('resetView');
        window.frames.scaleModel.pc.app
          .fire('setDirectionVal', 286, 250);
        window.frames.scaleModel.pc.app
          .fire('setPitchVal', -16.5);
      } catch (e) {
        console.warn('error resetting view', e);
      }
    },
    updateUnitsToShow() {
      if (this.loaded) {
        this.clearModelUnits();
        if (this.showUnits) {
          this.showModelUnits();
        }
      }
    },
    updateDirection() {
      if (this.loaded && this.showUnits) {
        if (this.filteredFloorplanList.length > 0) {
          this.setDirection();
        } else {
          this.resetView();
        }
      }
    },
    resizeToFixModel() {
      this.resizingModel = true;
      setTimeout(() => {
        document.getElementById('availability-scale-model').style.width = '0';
        setTimeout(() => {
          document.getElementById('availability-scale-model').style.width = 'auto';
        });
        this.setPageReady(true);
        window.frames.scaleModel.pc.app
          .fire('setSection', 'floorplans');
        console.log('setSection Floorplans?');
      }, 2000, this);
    },
    modelLoaded() {
      setTimeout(() => {
        this.loaded = true;
        if (!this.resizingModel) {
          this.setPageReady(true);
        }
        window.frames.scaleModel.pc.app
          .fire('setSection', 'floorplans');
        this.updateUnitsToShow();
        this.setDirection();

        window.frames.scaleModel.pc.app
          .fire('hideUnits');

        const colourBg = this.colours.find(colour => colour.name === 'background');
        const rgbBg = this.hslToRgb(colourBg);
        window.frames.scaleModel.pc.app
          .fire('setBGColour', rgbBg);
        const colourFiltered = this.colours.find(colour => colour.name === 'availability-filtered');
        const colourFloorplan = this.colours.find(colour => colour.name === 'availability-floorplan');
        const colourSelected = this.colours.find(colour => colour.name === 'availability-unit');
        const rgbFiltered = this.hslToRgb(colourFiltered);
        const rgbFloorplan = this.hslToRgb(colourFloorplan);
        const rgbSelected = this.hslToRgb(colourSelected);
        window.frames.scaleModel.pc.app
          .fire('setUnitColours', {
            filtered: rgbFiltered,
            floorplan: rgbFloorplan,
            selected: rgbSelected
          });
      }, 100, this);
    },
    unitClicked(unitName) {
      // console.log('unit clicked', unitName);
      if (this.showUnits && this.filteredUnitList.find(unit => unit === unitName)) {
        this.$router.push({
          name: 'FloorplanDetail',
          params: { id: this.getFloorplanByUnitName(unitName).id }
        });
        this.setSelectedUnitName(unitName);
      }
    },
    hslToRgb(hsl) {
      const h = parseInt(hsl.h, 10) / 360;
      const s = parseInt(hsl.s.replace('%', ''), 10) / 100;
      const l = parseInt(hsl.l.replace('%', ''), 10) / 100;
      let r;
      let g;
      let b;

      if (s === 0) {
        r = l;
        g = l;
        b = l;
      } else {
        const hue2rgb = (px, qx, tx) => {
          const p = px;
          const q = qx;
          let t = tx;
          if (t < 0) t += 1;
          if (t > 1) t -= 1;
          if (t < 1 / 6) return p + (q - p) * 6 * t;
          if (t < 1 / 2) return q;
          if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
          return p;
        };

        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }

      return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
      };
    },
    applyFirstLoadSuitesRotation() {
      // first load, query url present
      if (!this.firstLoadRotation) {
        // console.log('apply first load rotation');
        if (this.$route.query.suites) {
          const val = this.$route.query.suites;
          if (val === 'summerwind') {
            window.frames.scaleModel.pc.app
              .fire('setDirectionVal', 141, 250);
          } else if (val === 'skye') {
            window.frames.scaleModel.pc.app
              .fire('setDirectionVal', 288, 250);
          } else if (val === 'sealoge') {
            window.frames.scaleModel.pc.app
              .fire('setDirectionVal', 270, 250);
          } else if (val === 'cityscape') {
            window.frames.scaleModel.pc.app
              .fire('setDirectionVal', 89, 250);
          }
        }
        // console.log('apply first load rotation ended');
        this.firstLoadRotation = true;
      }
    }
  },
  watch: {
    selectedUnitName() {
      this.updateUnitsToShow();
      this.updateDirection();
    },
    showUnits() {
      // console.log('showunits changed?');
      this.updateUnitsToShow();
      if (this.isFiltered || this.$route.name === 'FloorplanDetail') {
        this.updateDirection();
      } else {
        this.resetView();
      }
    },
    filteredUnitList() {
      // console.log('filteredunitList change');
      this.updateUnitsToShow();
      this.updateDirection();
      if (!this.firstLoadRotation && this.loaded) {
        this.applyFirstLoadSuitesRotation();
      }
    },
    $route() {
      // console.log('route change');
      this.updateUnitsToShow();
      this.updateDirection();
    }
  },
  mounted() {
    if (!window.modelReady) {
      window.modelReady = this.modelLoaded.bind(this);
    }
    window.pcUnitClicked = this.unitClicked.bind(this);
    window.triggerResize = this.resizeToFixModel.bind(this);
  },
  beforeDestroy() {
    window.modelReady = null;
    window.pcUnitClicked = null;
    window.triggerResize = null;
  }
};
</script>

<style lang="scss" scoped>
#availability-scale-model {
  // position: relative;
}

#availability-scale-model, #scale-model {
  height: 100%;
  width: 100%;
}

.model-debug {
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  color: black;
}

.interact-instructions {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.interact-instructions-text {
  width: 130px;
  position: relative;
  color: white;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: hsla(0, 0, 0, 0.8);
  border-radius: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/Availability/AvailabilityScaleModel.vue